/** Location / block options for operator New Project Request (Dhamnagar district). */
export const OPERATOR_LOCATION_BLOCKS = [
  'Dhamnagar',
  'Dhamnagar NAC',
  'Tihidi',
  'Tihidi NAC',
  'Dhusuri NAC',
] as const;

export type OperatorLocationBlock = (typeof OPERATOR_LOCATION_BLOCKS)[number];

export const DEFAULT_OPERATOR_LOCATION_BLOCK: OperatorLocationBlock = 'Dhamnagar';

/** Blocks that are NAC — GP is auto-fixed to "NAC". */
export const NAC_BLOCKS: ReadonlySet<string> = new Set(['Dhamnagar NAC', 'Tihidi NAC', 'Dhusuri NAC']);

/** Gram Panchayat list per block. */
export const GP_BY_BLOCK: Readonly<Record<string, string[]>> = {
  'Dhamnagar': [
    'BHAGABANPUR', 'GADIALI', 'NADIGAN', 'KATASAHI', 'DAIPUR', 'KHAPARPADA',
    'BHATTASAHI', 'MUSTAFAPUR', 'HASNABAD', 'DHUSURI', 'GOVINDPUR', 'ARJUNNPUR',
    'DALANGA', 'PADHANI', 'KASIMPUR', 'KHADIPADA', 'KARADA', 'DOBAL', 'FATEPUR',
    'SAHASPUR', 'BAMKURA', 'KOTHAR', 'PALASAHI', 'KALYANI', 'CHUDAKUTI',
    'RADHABALABHPUR', 'ANANDAPUR', 'BAYANGDIHI', 'RAIPUR', 'SOHADA', 'ASURALI',
  ],
  'Tihidi': [
    'BILANA', 'KANPADA', 'KUBERA', 'ACHAK', 'TALAPADA', 'NAYANANDA', 'DOLASAHI',
    'TALAGOPABINDHA', 'BARO', 'SHYAMSUNDARPUR', 'BODAK', 'GUAMAL', 'PALIABINDHA',
  ],
  'Dhamnagar NAC': ['NAC'],
  'Tihidi NAC':    ['NAC'],
  'Dhusuri NAC':   ['NAC'],
};
